export default __webpack_public_path__ + "static/media/table-sort-icon-down.55331fd7.svg";